export const MEDIA_SERVER_DOMAINS = [
  'localhost',
  'i.iheart.com',
  'i-stg.iheart.com',
  'iscale.iheart.com',
];
